export const validatorsPerField = {
  default: [{ method: "lessEqualThanForTopUpAmount", args: [10000] }],
};
